@if (params; as p) {
<div class="panel-view-wrapper">
  <div class="panel-view-header">
    <div class="left-container">
      @if (!params.data.systemGenerated) {
      <button
        id="add-watch-order"
        mat-stroked-button
        color="primary"
        class="add-watch-order"
        (click)="onAddWatchOrder()"
      >
        <mat-icon>add</mat-icon>
        <span>Add Watch Order</span>
      </button>
      } @if (!params.data.systemGenerated) {
      <div id="divider"></div>
      }
      <span class="icon-group">
        <div class="material-icons-outlined">
          <span
            id="bulk-action-move-order"
            class="bulk-action-icons move-action-icon"
            [ngClass]="{ disabled: actionDisabled }"
            matTooltipPosition="below"
            matTooltip="Move order(s) to selected alert"
            [matTooltipDisabled]="actionDisabled"
            (click)="moveOrders()"
            #moveIcon
            >drive_file_move</span
          >
          @if (!isSystemAlert) {
          <span
            id="bulk-action-copy-order"
            class="bulk-action-icons copy-action-icon"
            [ngClass]="{ disabled: copyDisabled }"
            matTooltipPosition="below"
            matTooltip="Copy order(s) to selected alert"
            [matTooltipDisabled]="actionDisabled"
            (click)="copyOrders()"
            #copyIcon
            >copy_all</span
          >
          } @if (!isSystemAlert) {
          <span
            id="bulk-action-remove-order"
            class="bulk-action-icons remove-action-icon"
            [ngClass]="{ disabled: actionDisabled }"
            matTooltipPosition="below"
            matTooltip="Remove watch order(s)"
            [matTooltipDisabled]="actionDisabled"
            (click)="removeWatchOrders()"
            >remove_circle_outline</span
          >
          }
        </div>
      </span>
    </div>
    <div class="right-container">
      <button
        id="adjust-hit-overview-link"
        class="button-link"
        (click)="openAdjustExistingHitOverview()"
      >
        Adjust Hit Overview
      </button>
    </div>
  </div>
  <div class="panel-body" #panelBody>
    <app-reference-chips
      [label]="CLIENT_REFERENCE_LABEL"
      [referenceChips]="clientReference"
    ></app-reference-chips>
    <app-reference-chips
      [label]="SUB_CLIENT_REFERENCE_LABEL"
      [referenceChips]="subClientReference"
    ></app-reference-chips>
    <span>Watch Orders</span>
    <app-watch-alerts-orders-grid
      [orders]="orders"
      [loading]="loading"
      [error]="error"
      [parentGridApi]="params.api"
      [currentAlertId]="params.data?.originalId || params.data?.id"
      (gridHeightChange)="onGridHeightChange($event)"
      (selectionChanged)="onOrdersSelectionChanged($event)"
    ></app-watch-alerts-orders-grid>
  </div>
</div>
}
